import MUIMenuItem from '@mui/material/MenuItem';
import { ReactNode } from 'react';

type MenuItemProps = {
    label: string | ReactNode;
    icon?: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
};

export default function MenuItem({
    onClick,
    label,
    icon,
    disabled,
}: MenuItemProps) {
    return (
        <MUIMenuItem
            dense
            sx={{
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
            {icon}
        </MUIMenuItem>
    );
}
